/* Home Store Online – home page behaviour (collection rail, family chips, size finder).
   Plain script, no dependencies. Re-runs when a section is re-rendered in the theme editor. */
(function () {
  'use strict';
  var $$ = function (sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); };

  /* ---------- rails: arrow buttons ---------- */
  function initRails(scope) {
    $$('[data-hs-home-rail]', scope).forEach(function (r) {
      if (r.dataset.ready) return;
      r.dataset.ready = '1';
      var wrap = document.createElement('div');
      wrap.className = 'rail-wrap';
      r.parentNode.insertBefore(wrap, r);
      wrap.appendChild(r);
      function mk(cls, label, dir, path) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rail-btn ' + cls;
        b.setAttribute('aria-label', label);
        b.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="' + path + '"/></svg>';
        b.addEventListener('click', function () { r.scrollBy({ left: dir * r.clientWidth * 0.8, behavior: 'smooth' }); });
        wrap.appendChild(b);
        return b;
      }
      var prev = mk('rail-btn--prev', 'Scroll left', -1, 'm15 5-7 7 7 7');
      var next = mk('rail-btn--next', 'Scroll right', 1, 'm9 5 7 7-7 7');
      function update() {
        prev.disabled = r.scrollLeft < 8;
        next.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 8;
      }
      r.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
      r._hsUpdate = update;
    });
  }

  /* ---------- collection families (chips filter the rail) ---------- */
  function initChips(scope) {
    $$('[data-fam-tabs]', scope).forEach(function (group) {
      if (group.dataset.ready) return;
      group.dataset.ready = '1';
      var section = group.closest('[data-hs-colls]');
      var rail = section && section.querySelector('[data-hs-home-rail]');
      $$('[data-fam]', group).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var fam = btn.dataset.fam;
          $$('[data-fam]', group).forEach(function (b) {
            var on = b === btn;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          if (!rail) return;
          $$('.coll-tile', rail).forEach(function (t) { t.hidden = fam !== 'all' && t.dataset.fam !== fam; });
          rail.scrollTo({ left: 0 });
          if (rail._hsUpdate) rail._hsUpdate();
        });
      });
    });
  }

  /* ---------- size finder ---------- */
  var RUG_SIZES = [[80, 150], [120, 170], [150, 200], [160, 230], [200, 290], [240, 340]];
  var RUNNERS = [[66, 200], [60, 230], [66, 230], [80, 300]];
  var NOTES = {
    living: 'the front legs of the sofa sit on the rug with floor showing all round',
    bed: 'the rug sits under the lower two-thirds of a double bed',
    kingbed: 'the rug sits under the lower two-thirds of a king-size bed',
    dining: 'the chairs stay on the rug when they are pulled out'
  };
  var IDEAL = { living: [160, 230], bed: [160, 230], kingbed: [200, 290], dining: [200, 290] };
  function recommend(room, W, L) {
    var w = Math.min(W, L) * 100, l = Math.max(W, L) * 100;
    if (room === 'hall') {
      var fitR = RUNNERS.filter(function (r) { return r[0] <= w - 20 && r[1] <= l - 40; })
        .sort(function (x, y) { return (y[1] - x[1]) || (y[0] - x[0]); });
      return { size: fitR[0] || RUNNERS[0], band: 'runner',
        note: fitR[0] ? 'there is floor showing at both ends and down the sides' : 'your hallway is compact, so choose the shortest runner' };
    }
    var clear = 45, ideal = IDEAL[room] || IDEAL.living;
    var fit = RUG_SIZES.filter(function (r) { return r[0] <= w - 2 * clear && r[1] <= l - 2 * clear; });
    var small = fit.filter(function (r) { return r[0] * r[1] <= ideal[0] * ideal[1] * 1.6; });
    var pick = small.length ? small[small.length - 1] : (fit.length ? fit[fit.length - 1] : RUG_SIZES[0]);
    if (room === 'dining' && pick[0] < 200 && fit.length) pick = fit[fit.length - 1];
    var area = pick[0] * pick[1];
    var band = area < 36000 ? 'small' : area < 58000 ? 'large' : 'xl';
    return { size: pick, band: band, note: NOTES[room] || NOTES.living };
  }
  function initFinder(scope) {
    $$('[data-hs-finder]', scope).forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      var out = form.parentNode.querySelector('[data-hs-finder-out]');
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var W = parseFloat(form.elements.w.value) || 3, L = parseFloat(form.elements.l.value) || 4;
        var r = recommend(form.elements.room.value, W, L);
        var link = form.dataset['link' + r.band.charAt(0).toUpperCase() + r.band.slice(1)] || '/collections/all';
        var label = form.dataset['label' + r.band.charAt(0).toUpperCase() + r.band.slice(1)] || 'rugs in this size';
        out.innerHTML = 'Try <b>' + r.size[0] + ' x ' + r.size[1] + ' cm</b>, so ' + r.note + '. ' +
          '<a class="link-arrow" href="' + link + '">See ' + label + '</a>';
      });
    });
  }

  function init(scope) { initRails(scope); initChips(scope); initFinder(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
